import React from 'react';
import './App.css';
import { Router } from '@reach/router';

import Main from './components/main';
import Page from './components/page';

import HomePage from './components/sub-pages/home-page';
import AboutPage from './components/sub-pages/about-page';
import ServicesPage from './components/sub-pages/services-page';
import ProjectsPageCMS from './components/sub-pages/projects-page-cms';
import ProjectsPageFun from './components/sub-pages/projects-page-fun';
import ProjectsPageDev from './components/sub-pages/projects-page-dev';
import ContactPage from './components/sub-pages/contact-page';

const App = ({ history, location }) => (
  <Main history={history}>
    <Page location={location}>
      <Router>
        <HomePage path="/" />
        <AboutPage exact path="/about"/>
        <ProjectsPageDev path="/projects/mini-projects"/>
        <ProjectsPageCMS path="/projects/cms-clients"/>
        <ProjectsPageFun path="/random"/>
        <ServicesPage path="/services" />
        <ContactPage path="/contact" />
      </Router>
    </Page>
  </Main>
);

export default App;
